import { ShieldCheck } from "lucide-react";
import React from "react";

/**
 * A banner that displays a static, hard-coded version number for the dashboard.
 * It's styled to indicate a live, production environment.
 */
const VersionBanner = () => {
  // --- Hard-code your version number here ---
  const VERSION = "1.0.1";

  return (
    <div className="bg-teal-600 text-white py-2 mb-4 px-4 flex items-center justify-center text-center shadow-md">
      <div className="flex items-center justify-center gap-3">
        <ShieldCheck size={18} className="text-white flex-shrink-0" />
        <p className="text-sm font-medium tracking-wide">
          You are on the live version of Jace Ambulance Dashboard -{" "}
          <strong className="font-bold bg-teal-500 px-2 py-0.5 rounded-md">
            v{VERSION}
          </strong>
        </p>
      </div>
    </div>
  );
};

export default VersionBanner;